export default [{
	titulo: 'Linha do Tempo',
	icone: 'menu-icon fa fa-caret-right',
	url: '/site/linha-do-tempo',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]